import HeroSec from "./HeroSec";


export default function Segment1(){
    return(
    <div className="seg1">
        <HeroSec/>
    </div>
    )
}